import React from "react";
import SalaryPaymentsGenericSkeleton from "./SalaryPaymentsGenericSkeleton";

function SalaryPaymentsDetailSkeleton() {
  return (
    <>
      <SalaryPaymentsGenericSkeleton />
    </>
  );
}

export default SalaryPaymentsDetailSkeleton;
